export default "__VITE_ASSET__C0Jw3hFv__"